<template>
  <!-- {{ cajaStore.lastCaja?.fecha }} -->
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <div class="d-flex align-center mb-4">
      <DatePicker v-model="selectedDate" />
    </div>
    <v-data-table-server
      :items="facturas"
      :items-per-page="perPage"
      :items-length="totalFacturas"
      :headers="headers"
      :page="page"
      :loading="loading"
      :item-value="id"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
      class="elevation-1"
      show-expand
      expand-on-click="false"
      :expanded="expanded"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-text-field
            v-model="facturasStore.search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            @input="loadFacturas"
          ></v-text-field> -->
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="newItem()"
            >Nuevo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.caja_fecha`]="{ item }">
        {{ formatDate(item.caja_fecha) }}
      </template>
      <template v-slot:[`item.importe`]="{ item }">
        {{ formatCurrency(item.importe) }} €
      </template>
      <template #[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" color="green">
          mdi-pencil
        </v-icon>
        <!-- <v-icon small @click="deleteItem(item)" color="red">
          mdi-delete
        </v-icon> -->
      </template>
      <template v-slot:expanded-row="{ item }">
        <tr
          v-if="item.detalle && item.detalle.trim() !== ''"
          class="expanded-detalle"
        >
          <td :colspan="headers.length">
            <div class="pa-4">{{ item.detalle }}</div>
          </td>
        </tr>
      </template>
    </v-data-table-server>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useFacturasStore } from '@/stores/facturasStore'
import { useCajaStore } from '@/stores/cajaStore'
import DatePicker from '@/components/common/DatePicker.vue'
import NoPermission from '@/components/common/NoPermission.vue'
import { formatCurrency, formatDate, userIsRecepcion } from '@/utils/helpers'

const facturasStore = useFacturasStore()
const { facturas, totalFacturas, page, perPage } = storeToRefs(facturasStore)
const loading = ref(false)
const cajaStore = useCajaStore()
const selectedDate = ref(null)
const cajaReady = inject('cajaReady', ref(true)) // Default to true if not provided

const emit = defineEmits(['editItem', 'delete', 'newItem'])
const expanded = ref([])

const headers = [
  { title: 'Fecha', value: 'caja_fecha', align: 'center' },
  { title: 'Turno', value: 'turno', align: 'center' },
  { title: 'Usuario', value: 'usuario_iniciales', align: 'center' },
  { title: 'Número', value: 'numero', align: 'center' },
  { title: 'Importe', value: 'importe', align: 'end' },
  { title: '', key: 'data-table-expand' },
  {
    title: '  ',
    width: '100px',
    value: 'actions',
    sortable: false
  }
]

onMounted(async () => {
  // Inicializar la fecha seleccionada con la fecha de la caja en formato ANSI
  await cajaStore.getLastCaja()
  // Wait for cajaReady to be true before loading data
  if (cajaReady.value) {
    initializeData()
  } else {
    // Watch for changes in cajaReady
    const unwatch = watch(cajaReady, (newValue) => {
      if (newValue === true) {
        initializeData()
        unwatch() // Stop watching once initialized
      }
    })
  }
})

const initializeData = () => {
  // nextTick(async () => {
  const fecha = cajaStore.lastCaja?.fecha || new Date()
  if (fecha instanceof Date) {
    const year = fecha.getFullYear()
    const month = String(fecha.getMonth() + 1).padStart(2, '0')
    const day = String(fecha.getDate()).padStart(2, '0')
    selectedDate.value = `${year}-${month}-${day}`
  } else {
    selectedDate.value = fecha
  }
  // await loadFacturas()
  // })
}

// Observar cambios en la fecha seleccionada
watch(selectedDate, () => {
  loadFacturas()
})

const loadFacturas = async () => {
  let fecha = selectedDate.value || null
  // Ya no es necesario verificar si es Date, ya que selectedDate siempre será string

  await facturasStore.fetchFacturas({ fecha: fecha })
}

const onPageChange = (newPage) => {
  facturasStore.setPage(newPage)
  loadFacturas()
}

const onItemsPerPageChange = (newItemsPerPage) => {
  perPage.value = newItemsPerPage
  facturasStore.setRows(newItemsPerPage)
  loadFacturas()
}

// const deleteItem = (item) => {
//   emit('delete', item.id)
// }

const editItem = (item) => {
  emit('editItem', item)
}

const newItem = () => {
  emit('newItem')
}
</script>
